import { Button, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import styled from "styled-components";
import MarkerGroupRow from "./MarkerGroupRow";
import { useCustomMarkers } from "../../../hooks/useCustomMarkers";

const AddGroupButton = styled(Button)`
  border-radius: 8px;
  color: #eeeeee !important;
  background: #393e46 !important;
  margin-bottom: 12px;
  margin-top: 12px;
  &:hover {
    color: #8e1616 !important;
    background: #222831 !important;
    border-color: #8e1616 !important;
  }
`;

const GroupSpace = styled(Space)`
  width: 100%;
`;

export default function MarkersTab() {
  const { groups, addGroup, removeGroup, updateGroupColor, updateGroupName } =
    useCustomMarkers();

  return (
    <GroupSpace direction="vertical" size={12}>
      <AddGroupButton
        icon={<PlusOutlined />}
        type="dashed"
        block
        onClick={addGroup}
      >
        Add marker group
      </AddGroupButton>
      {groups
        .slice()
        .reverse()
        .map((g) => (
          <MarkerGroupRow
            key={g.id}
            id={g.id}
            color={g.color}
            name={g.name}
            onColorChange={(hex) => updateGroupColor(g.id, hex)}
            onNameChange={(name) => updateGroupName(g.id, name)}
            onRemove={() => removeGroup(g.id)}
          />
        ))}
    </GroupSpace>
  );
}
